import { values } from 'lodash';

const isNarrowed = (selection: any) => values(selection).includes(false);

// a selection the filters no longer offer would hold every row back, so it is given up
export const withOfferedSelections = (
  filtersApplied: any,
  requiredFilters: Array<string>,
  filterCountState: any,
  isPreorder?: boolean
) => {
  if (!isPreorder || !filtersApplied || !filterCountState?.offered) return filtersApplied;
  const updated = { ...filtersApplied };
  let isPruned = false;

  requiredFilters.forEach((filter: string) => {
    const selection = filtersApplied[filter];
    const offered = filterCountState.offered[filter];
    // an option of another tab is not this data's to give up
    const known = filterCountState.absolute?.[filter];
    if (!selection || !offered || !known || !isNarrowed(selection)) return;

    const kept = { ...selection };
    const dropped = Object.keys(kept).filter(
      (option) => kept[option] && known[option] && !offered[option]
    );
    if (!dropped.length) return;

    dropped.forEach((option) => (kept[option] = false));
    // giving up every option of a filter leaves nothing to show, so it goes back to all of them
    if (!values(kept).includes(true)) Object.keys(kept).forEach((option) => (kept[option] = true));
    updated[filter] = kept;
    isPruned = true;
  });

  return isPruned ? updated : filtersApplied;
};
